<div class="progress-bar" [ngStyle]="{'width':pourcent + '%'}"></div>
<div class="circle" *ngFor="let step of steps" [ngStyle]="{'left':step + '%'}"></div>
